import { render, staticRenderFns } from "./menuheader.vue?vue&type=template&id=4427b19d&scoped=true"
import script from "./menuheader.vue?vue&type=script&lang=js"
export * from "./menuheader.vue?vue&type=script&lang=js"
import style0 from "./menuheader.vue?vue&type=style&index=0&id=4427b19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4427b19d",
  null
  
)

export default component.exports